import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { environment } from 'environments/environment';
import { OffersDialogComponent } from '../offers-dialog/offers-dialog.component';

@Component({
  selector: 'mpf-map-config-offers',
  templateUrl: './map-config-offers.component.html',
  styleUrls: ['./map-config-offers.component.scss']
})
export class MapConfigOffersComponent {
  smartphoneDialogSize = {
    height: '100%',
    width: '100%',
    maxWidth: '100%'
  };

  constructor(public dialog: MatDialog) {}

  openOffersDialog(event: MouseEvent) {
    event.preventDefault();

    const dialogRef = this.dialog.open(OffersDialogComponent, this.getOffersDialogConfig());

    const updateDialogSize = () => {
      const offersDialogConfig = this.getOffersDialogConfig();
      dialogRef.updateSize(offersDialogConfig.width, offersDialogConfig.height);
      dialogRef.updatePosition();
    };

    window.addEventListener('resize', updateDialogSize);

    dialogRef.afterClosed().subscribe(() => {
      window.removeEventListener('resize', updateDialogSize);
    });
  }

  getOffersDialogConfig() {
    const windowWidth = window.innerWidth;

    if (windowWidth < environment.screen.smartphone) {
      return this.smartphoneDialogSize;
    } else {
      return {
        height: '580px',
        width: '475px'
      };
    }
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/map-config-offers/map-config-offers.component.ts